import { Messages } from '../../codegen/Localize';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { IValidateCustomOAuthConfigResult, ValidateCustomOAuthConfigRequest } from '../serverApi/requests/OAuth/ValidateCustomOAuthConfigRequest';

// revise the regex pattern from https://www.tutorialspoint.com/How-to-validate-URL-address-in-JavaScript
const urlPattern = new RegExp('^(https?:\\/\\/)' + // protocol
  '((([a-z\\d]([a-z\\d-_]*[a-z\\d])*)\\.)+[a-z]{1,}|localhost|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

// redirectUrl matching pattern.
const redirectUrlPattern = new RegExp('(?=^.{1,256}$)' + //length limit
  '(^(https?:\\/\\/)' + // protocol
  '(?:(?!\\.|-)([a-zA-Z0-9_\\-]\\.?)+)' + // domain name(Matches any FQDNs or non-FQDNs except those starting with '.' or '-', in accordance with the oauth spec guidelines for redirect_url registration)
  '(\\:\\d+)?' + // port
  '(\\/auth\\/add_oauth_token))');// redirectUrl path has to be /auth/add_oauth_token

const embeddedWhiteSpace = /\s/;

export const ACCEPTED_FILE_TYPES = ['.xml'];
export const FILE_SIZE_LIMIT = 2 * 1024 * 1024;

function validateUrl(value: string): boolean {
  return !!urlPattern.test(value);
}

function validateRedirectUrl(value: string): boolean {
  if (value.startsWith('http://')) {
    // revised from http://scratch99.com/web-development/javascript/how-to-get-the-domain-from-a-url/
    let domain = value.replace('http://', '').split(/[/?#:]/)[0];
    if (domain !== 'localhost') {
      return false;
    }
  }
  return !!redirectUrlPattern.test(value);
}

export function validateNoEmbeddedWhiteSpaceCI(value: string): string {
  if (!value || embeddedWhiteSpace.test(value)) {
    return Messages.invalidCI();
  }
  return '';
}

export function validateNoEmbeddedWhiteSpaceCS(value: string): string {
  if (embeddedWhiteSpace.test(value)) {
    return Messages.invalidCS();
  }
  return '';
}

export function validateInstanceUrl(value: string): string {
  let v: string;
  if (value && (v = value.trim()) && !validateUrl(v)) {
    return Messages.invalidUrl();
  }
  return '';
}

export function validateRedirectUri(value: string): string {
  if (!value || !validateRedirectUrl(value.trim())) {
    return Messages.invalidRedirectUrl();
  }
  return '';
}

export async function validateCustomOAuthConfig(stringContent: string, dbclass: string): Promise<IValidateCustomOAuthConfigResult> {
  return WebHttpClient.sendRequest(new ValidateCustomOAuthConfigRequest({ customOAuthConfig: stringContent, dbClass: dbclass }));
}

/**
 * Helper method that Promises the file content of the uploaded file.
 *
 * @param fileInput XML File object uploaded by user.
 * @returns A promise for the string content of the uploaded file
 */
export const readFileContent = async (fileInput: File): Promise<string> => {
  let content = '';

  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException('Could not read file'));
    };
    reader.onloadend = (event) => {
      content = event.target.result as string;
      resolve(content);
    };
    reader.readAsText(fileInput, 'UTF-8');
  });
};
